/* Court Vibes, 18.09.2026. Favoriten, ohne App und ohne Anmeldung.

   Warum selbst gebaut: Shopify kann von Haus aus keine Merkliste, weder mit
   den alten noch mit den neuen Kundenkonten. Die fertigen Apps kosten ab
   rund 30 Dollar im Monat und laden ein weiteres Skript auf jeder Seite.
   Am 18.09.2026 gemessen lud courtvibes.de ohnehin schon 238 JavaScript-
   Dateien pro Seitenaufruf, deshalb bewusst diese schlanke Loesung.

   Was sie kann: ein Herz auf jeder Produktkachel und auf der Produktseite,
   eine Seite /pages/favoriten mit den gemerkten Produkten, ein Herz mit
   Zaehler im Kopfbereich.

   Was sie NICHT kann, und das ist Absicht, nicht vergessen:
   Die Liste liegt im Browser des Kunden (localStorage), nicht bei Shopify.
   Sie gilt nur auf diesem einen Geraet und ist weg, wenn jemand seine
   Browserdaten loescht. Houda sieht im Shopify-Adminbereich NICHT, was
   gemerkt wurde. Wer Auswertung und Erinnerungsmails will, braucht eine App.

   Gespeichert wird nur der Handle, also der Adressteil des Produkts, dazu
   der Titel als Notnagel und ein Zeitstempel. Preis, Bild und Verfuegbarkeit
   holt die Favoritenseite frisch, damit dort niemals ein veralteter Preis
   steht.

   Faellt die Datei aus, verschwinden nur die Herzen. Es geht nichts kaputt,
   keine andere Funktion haengt daran.

   Probe im Browser:
   getComputedStyle(document.documentElement).getPropertyValue('--cv-favoriten')
*/
(function () {
  var SCHLUESSEL = 'cv_favoriten_v1';
  var SEITE = '/pages/favoriten';
  var MAX = 100;

  var HERZ =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.6s-7.6-4.7-9.4-9A5.2 5.2 0 0 1 12 6.4a5.2 5.2 0 0 1 9.4 5.2c-1.8 4.3-9.4 9-9.4 9Z" ' +
    'fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

  /* ---------- Speicher ---------- */

  function lesen() {
    try {
      var r = JSON.parse(localStorage.getItem(SCHLUESSEL));
      return Array.isArray(r) ? r : [];
    } catch (e) {
      return [];
    }
  }

  function schreiben(liste) {
    try {
      localStorage.setItem(SCHLUESSEL, JSON.stringify(liste.slice(0, MAX)));
    } catch (e) {
      /* privater Modus oder Speicher voll, dann merkt sich der Browser eben nichts */
    }
  }

  function gemerkt(handle) {
    var l = lesen();
    for (var i = 0; i < l.length; i++) {
      if (l[i].handle === handle) return true;
    }
    return false;
  }

  function umschalten(handle, titel) {
    var l = lesen();
    var pos = -1;
    for (var i = 0; i < l.length; i++) {
      if (l[i].handle === handle) { pos = i; break; }
    }
    if (pos > -1) {
      l.splice(pos, 1);
    } else {
      l.unshift({ handle: handle, titel: titel || '', zeit: Date.now() });
    }
    schreiben(l);
    aktualisieren();
    return pos === -1;
  }

  function entfernen(handle) {
    var l = lesen().filter(function (e) { return e.handle !== handle; });
    schreiben(l);
    aktualisieren();
  }

  function handleAus(adresse) {
    if (!adresse) return null;
    var pfad = String(adresse).split('?')[0].split('#')[0];
    var t = pfad.split('/products/')[1];
    if (!t) return null;
    t = t.split('/')[0];
    return t || null;
  }

  /* ---------- Knopf ---------- */

  function knopfBauen(handle, titel, zusatz, beschriftung) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cv-herz' + (zusatz ? ' ' + zusatz : '');
    b.setAttribute('data-handle', handle);
    b.innerHTML = HERZ;
    if (beschriftung) {
      var s = document.createElement('span');
      s.className = 'cv-herz__text';
      s.textContent = 'Merken';
      b.appendChild(s);
    }
    b.addEventListener('click', function (e) {
      // Die Kachel liegt komplett unter einem Link, deshalb muss der Klick
      // hier gestoppt werden, sonst springt der Kunde auf die Produktseite.
      e.preventDefault();
      e.stopPropagation();
      var dazu = umschalten(handle, titel);
      if (dazu) hinweisZeigen();
    });
    return b;
  }

  function beschriften(b, an) {
    b.setAttribute('aria-pressed', an ? 'true' : 'false');
    b.setAttribute('title', an ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen');
    b.setAttribute('aria-label', an ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen');
    var t = b.querySelector('.cv-herz__text');
    if (t) t.textContent = an ? 'Gemerkt' : 'Merken';
  }

  function aktualisieren() {
    var anzahl = lesen().length;
    document.querySelectorAll('.cv-herz').forEach(function (b) {
      beschriften(b, gemerkt(b.getAttribute('data-handle')));
    });
    document.querySelectorAll('.cv-favoriten-zahl').forEach(function (z) {
      z.textContent = anzahl ? String(anzahl) : '';
      if (anzahl) { z.removeAttribute('hidden'); } else { z.setAttribute('hidden', ''); }
    });
    document.documentElement.setAttribute('data-cv-favoriten', String(anzahl));
  }

  /* ---------- Hinweis nach dem Merken ---------- */

  var hinweisZeit = null;

  function hinweisZeigen() {
    var d = document.querySelector('.cv-fav-hinweis');
    if (!d) {
      d = document.createElement('div');
      d.className = 'cv-fav-hinweis';
      d.setAttribute('role', 'status');
      d.innerHTML = 'Gemerkt. <a href="' + SEITE + '">Meine Favoriten</a>';
      document.body.appendChild(d);
    }
    d.classList.add('cv-fav-hinweis--an');
    clearTimeout(hinweisZeit);
    hinweisZeit = setTimeout(function () { d.classList.remove('cv-fav-hinweis--an'); }, 3500);
  }

  /* ---------- Einbau ---------- */

  function kacheln() {
    document.querySelectorAll('product-card').forEach(function (k) {
      if (k.querySelector('.cv-herz')) return;
      var g = k.querySelector('.card-gallery');
      if (!g) return;
      var a = k.querySelector('a[href*="/products/"]');
      var h = handleAus(a && a.getAttribute('href'));
      if (!h) return;
      var t = k.querySelector('.product-title, h3, h4');
      g.appendChild(knopfBauen(h, t ? t.textContent.trim() : '', 'cv-herz--kachel', false));
    });
  }

  function produktseite() {
    if (location.pathname.indexOf('/products/') === -1) return;
    if (document.querySelector('.cv-herz--produkt')) return;
    var h = handleAus(location.pathname);
    if (!h) return;
    var titel = document.querySelector('.product-details h1, main h1, h1');
    if (!titel) return;
    var zeile = document.createElement('div');
    zeile.className = 'cv-herz-zeile';
    zeile.appendChild(knopfBauen(h, titel.textContent.trim(), 'cv-herz--produkt', true));
    titel.insertAdjacentElement('afterend', zeile);
  }

  function kopfbereich() {
    if (document.querySelector('.cv-favoriten-kopf')) return;
    var korb = document.querySelector('cart-drawer-component');
    if (!korb || !korb.parentElement) return;
    var a = document.createElement('a');
    a.href = SEITE;
    a.className = 'cv-favoriten-kopf header-actions__action button-unstyled';
    a.setAttribute('aria-label', 'Favoriten');
    a.innerHTML = HERZ + '<span class="cv-favoriten-zahl" hidden></span>';
    korb.parentElement.insertBefore(a, korb);
  }

  /* ---------- Favoritenseite ----------
     21.09.2026 umgebaut. Houda: auf der Favoritenseite fehlen die Farbkreise,
     beim Schweben passiert nichts, die Kacheln sehen nicht aus wie im Shop.
     Grund: die Seite hat bisher eigene, vereinfachte Karten gebaut.

     Jetzt holt sie die ECHTEN Kacheln des Themes. Dafuer wird die Suchseite
     im Hintergrund mit den Produkttiteln abgefragt, etwa
     title:"Ich wohne jetzt hier" OR title:"Tennis Time Kinder-Shirt".
     Aus dem Ergebnis werden nur die gemerkten Produkte uebernommen, in der
     Reihenfolge der Merkliste. Die Suchkacheln sind seit 21.09.2026 genauso
     eingestellt wie die Kollektionskacheln, also sehen die Favoriten jetzt
     automatisch genauso aus, mit Farbkreisen und Bildwechsel beim Schweben.

     Wer die Kacheln der Suchseite aendert, aendert damit auch die Favoriten.

     Faellt die Suche aus oder fehlt ein Produkt im Ergebnis, springen fuer
     diese Produkte die alten einfachen Karten ein, damit nie etwas fehlt. */

  function preis(cent) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
    } catch (e) {
      return (cent / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function bild(p) {
    var q = p.featured_image || (p.images && p.images[0]);
    if (!q) return '';
    if (q.indexOf('//') === 0) q = 'https:' + q;
    // Nicht das Original ausliefern, die Dateien sind 2048 Pixel breit.
    return q + (q.indexOf('?') > -1 ? '&' : '?') + 'width=500';
  }

  function sicher(text) {
    var d = document.createElement('div');
    d.textContent = text == null ? '' : String(text);
    return d.innerHTML;
  }

  function behaelter() {
    var z = document.getElementById('cv-favoriten-liste');
    if (z) return z;
    var haupt = document.querySelector('main .page-content, main .shopify-section, main');
    if (!haupt) return null;
    z = document.createElement('div');
    z.id = 'cv-favoriten-liste';
    haupt.appendChild(z);
    return z;
  }

  function leer(ziel) {
    ziel.innerHTML =
      '<p class="cv-fav-leer">Du hast noch nichts gemerkt. Klick auf das Herz an einem Design, ' +
      'dann findest du es hier wieder.</p>' +
      '<p class="cv-fav-leer"><a class="button" href="/collections/designs">Designs ansehen</a></p>';
  }

  // Ersatzkarten, nur fuer Produkte, die die Suche nicht liefert.
  function einfacheKarten(produkte) {
    var teile = produkte.map(function (p) {
      var b = bild(p);
      return (
        '<li class="cv-fav-karte">' +
          '<a class="cv-fav-link" href="/products/' + p.handle + '">' +
            (b ? '<img class="cv-fav-bild" src="' + sicher(b) + '" alt="" loading="lazy">' : '<span class="cv-fav-bild"></span>') +
            '<span class="cv-fav-titel">' + sicher(p.title) + '</span>' +
            '<span class="cv-fav-preis">' + preis(p.price) + (p.available ? '' : ' · ausverkauft') + '</span>' +
          '</a>' +
          '<button type="button" class="cv-herz cv-herz--kachel" data-handle="' + p.handle + '">' + HERZ + '</button>' +
        '</li>'
      );
    });
    var ul = document.createElement('ul');
    ul.className = 'cv-fav-raster';
    ul.innerHTML = teile.join('');
    ul.querySelectorAll('.cv-herz').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        umschalten(b.getAttribute('data-handle'), '');
      });
    });
    return ul;
  }

  function suchen(produkte) {
    var pakete = [];
    for (var i = 0; i < produkte.length; i += 10) pakete.push(produkte.slice(i, i + 10));
    return Promise.all(
      pakete.map(function (pk) {
        var q = pk.map(function (p) {
          return 'title:"' + String(p.title).replace(/"/g, '') + '"';
        }).join(' OR ');
        return fetch('/search?type=product&q=' + encodeURIComponent(q))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })
    );
  }

  // Entfernt nach einem Klick aufs Herz die Kacheln, die nicht mehr gemerkt sind.
  function aufraeumen(ziel) {
    ziel.querySelectorAll('.cv-herz').forEach(function (b) {
      var h = b.getAttribute('data-handle');
      if (gemerkt(h)) return;
      var k = b.closest('li');
      if (k) k.remove();
    });
    if (!lesen().length) leer(ziel);
  }

  function seiteFuellen() {
    if (location.pathname.replace(/\/+$/, '') !== SEITE) return;
    var ziel = behaelter();
    if (!ziel) return;
    var liste = lesen();

    if (!liste.length) { leer(ziel); return; }

    ziel.innerHTML = '<p class="cv-fav-laedt">Einen Moment, deine Favoriten werden geladen.</p>';

    if (!ziel.getAttribute('data-cv-klick')) {
      ziel.setAttribute('data-cv-klick', '1');
      // Einfangphase, weil der Herzknopf das Weiterreichen des Klicks stoppt.
      ziel.addEventListener('click', function (e) {
        if (!e.target.closest || !e.target.closest('.cv-herz')) return;
        setTimeout(function () { aufraeumen(ziel); }, 0);
      }, true);
    }

    Promise.all(
      liste.map(function (e) {
        return fetch('/products/' + encodeURIComponent(e.handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (daten) {
      var produkte = [];
      daten.forEach(function (p, i) {
        if (!p) { entfernen(liste[i].handle); return; }
        produkte.push(p);
      });
      if (!produkte.length) { leer(ziel); return; }

      return suchen(produkte).then(function (seiten) {
        var karten = {};
        var vorlage = null;
        var stile = [];
        seiten.forEach(function (html) {
          if (!html) return;
          var d = new DOMParser().parseFromString(html, 'text/html');
          var sec = d.querySelector('.shopify-section[id$="__main"]');
          var ul = sec && sec.querySelector('ul.product-grid');
          if (!ul) return;
          if (!vorlage) {
            vorlage = sec;
            // Shopify buendelt das CSS der Kachel-Bausteine pro Seite in einer
            // eigenen Datei compiled_assets/styles.css. Die Favoritenseite hat
            // eine andere, ohne die Kachelregeln. Ohne dieses Nachladen stand
            // am 21.09.2026 der Knopf Auswaehlen dauerhaft sichtbar auf jeder
            // Kachel, weil die Regel opacity 0 fehlte.
            var da = {};
            document.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) { da[l.href] = 1; });
            d.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) {
              var h = new URL(l.getAttribute('href'), location.href).href;
              if (h.indexOf('compiled_assets') === -1 || da[h]) return;
              var n = document.createElement('link');
              n.rel = 'stylesheet';
              n.href = h;
              document.head.appendChild(n);
            });
            d.querySelectorAll('style').forEach(function (s) {
              if (s.textContent.indexOf('product-grid--') > -1) stile.push(s);
            });
          }
          Array.prototype.forEach.call(ul.children, function (li) {
            var a = li.querySelector('a[href*="/products/"]');
            var h = handleAus(a && a.getAttribute('href'));
            if (h && !karten[h]) karten[h] = li;
          });
        });

        var fehlend = [];
        ziel.innerHTML = '';

        if (vorlage) {
          var raster = vorlage.querySelector('ul.product-grid');
          while (raster.firstChild) raster.removeChild(raster.firstChild);
          produkte.forEach(function (p) {
            if (karten[p.handle]) raster.appendChild(karten[p.handle]);
            else fehlend.push(p);
          });
          vorlage.querySelectorAll(
            '.facets-toggle, .facets-block-wrapper, facets-form-component, .main-collection-grid__title, .skip-to-content-link, .pagination, pagination-component'
          ).forEach(function (e) { e.remove(); });
          stile.forEach(function (s) { ziel.appendChild(document.importNode(s, true)); });
          if (raster.children.length) ziel.appendChild(document.importNode(vorlage, true));
        } else {
          fehlend = produkte;
        }

        if (fehlend.length) ziel.appendChild(einfacheKarten(fehlend));
        kacheln();
        aktualisieren();
      });
    });
  }

  /* ---------- Start ---------- */

  var angestossen = null;

  function lauf() {
    kacheln();
    produktseite();
    kopfbereich();
    aktualisieren();
  }

  function anstossen() {
    clearTimeout(angestossen);
    angestossen = setTimeout(lauf, 80);
  }

  function start() {
    lauf();
    seiteFuellen();
    // Die Kollektionsseite tauscht beim Filtern ihr Raster gegen frisches
    // Server-HTML aus, dabei gehen die Herzen verloren. Deshalb beobachten.
    try {
      new MutationObserver(anstossen).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    // Andere Tabs desselben Browsers halten die Liste gleich.
    window.addEventListener('storage', function (e) {
      if (e.key === SCHLUESSEL) aktualisieren();
    });
    document.documentElement.style.setProperty('--cv-favoriten', 'on');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
